import React from 'react';
import './Home.css';
import AmbientStage from '../components/AmbientStage';
import RotatingDisc from '../components/RotatingDisc';
import MobileTicker from '../components/MobileTicker';
import BottomNav from '../components/BottomNav';

const events = [
  { code: '01', title: 'Live Machinery Demos', place: 'Hall A', time: '6:30 PM' },
  { code: '02', title: 'Buyer Matchmaking', place: 'Lounge B', time: '7:15 PM' },
  { code: '03', title: 'Sustainable Production', place: 'Studio C', time: '8:00 PM' },
];

function Home({ activeScreen, onNavigate }) {
  return (
    <AmbientStage className="home-screen">
      <div className="home-top">
        <div>
          <p className="eyebrow">Welcome back</p>
          <h2>Tonight's industrial pulse.</h2>
        </div>
        <button className="notification-button" type="button" aria-label="Notifications">03</button>
      </div>

      <div className="pass-card">
        <div>
          <span>Digital Pass</span>
          <strong>Textile Future 26</strong>
          <p>Hall A - Visitor - 06:30 PM</p>
        </div>
        <RotatingDisc label="Valid" detail="Today" />
      </div>

      <MobileTicker />

      <div className="quick-actions">
        <button type="button"><span>Ticket</span></button>
        <button type="button"><span>Map</span></button>
        <button type="button"><span>Book</span></button>
        <button type="button"><span>Rate</span></button>
      </div>

      <section className="event-feed" aria-label="Featured events">
        <div className="section-heading">
          <h3>Live Schedule</h3>
          <span>Now</span>
        </div>
        {events.map((event) => (
          <button className="feed-card" key={event.title} onClick={() => onNavigate('EventDetails')} type="button">
            <strong>{event.code}</strong>
            <div>
              <h4>{event.title}</h4>
              <p>{event.place} - {event.time}</p>
            </div>
          </button>
        ))}
      </section>

      <BottomNav activeScreen={activeScreen} onNavigate={onNavigate} />
    </AmbientStage>
  );
}

export default Home;
